import { computeMockAnalysisOutcome } from "./requestAnalysisMock";
import { getRequests, patchRequestAnalysis, uid } from "./adminInboxStore";

const pendingTimers = new Map();

function clearJob(requestId) {
  const t = pendingTimers.get(requestId);
  if (t != null) {
    window.clearTimeout(t);
    pendingTimers.delete(requestId);
  }
}

function runFinish(requestId, opts) {
  pendingTimers.delete(requestId);
  const fresh = getRequests().find((r) => r.id === requestId);
  if (!fresh || fresh.aiAnalysis?.status !== "pending") return;

  const mergedNote = (
    (opts.note != null ? opts.note : "") ||
    fresh.aiAnalysis?.instructionNote ||
    ""
  ).trim();
  const outcome = computeMockAnalysisOutcome(fresh, { ...opts, note: mergedNote });
  const run = {
    id: uid(),
    at: new Date().toISOString(),
    mode: opts.auto ? "auto" : opts.mode || "standard",
    ok: outcome.ok,
    summary: outcome.ok ? outcome.summary : "",
    error: outcome.ok ? "" : outcome.error,
    note: mergedNote || null,
  };
  const prevRuns = Array.isArray(fresh.aiAnalysis?.runs) ? fresh.aiAnalysis.runs : [];
  const runs = [...prevRuns, run].slice(-12);

  patchRequestAnalysis(requestId, {
    status: outcome.ok ? "ok" : "error",
    summary: outcome.ok ? outcome.summary : fresh.aiAnalysis.summary || "",
    error: outcome.ok ? "" : outcome.error,
    updatedAt: new Date().toISOString(),
    attempts: (fresh.aiAnalysis.attempts || 0) + 1,
    runs,
    pendingMode: null,
    pendingNote: null,
  });
}

/**
 * New submissions: auto-queue a mock GPT pass (real app → OpenAI here).
 */
export function queueAutomaticAnalysis(requestId) {
  clearJob(requestId);
  patchRequestAnalysis(requestId, {
    status: "pending",
    pendingMode: "standard",
    pendingNote: null,
  });
  const delayMs = 900 + Math.floor(Math.random() * 900);
  const t = window.setTimeout(() => {
    runFinish(requestId, { auto: true, mode: "standard", note: "" });
  }, delayMs);
  pendingTimers.set(requestId, t);
}

/**
 * Admin: re-analyse or detailed pass with optional team note.
 */
export function queueManualAnalysis(requestId, { mode, note }) {
  clearJob(requestId);
  patchRequestAnalysis(requestId, {
    status: "pending",
    pendingMode: mode,
    pendingNote: (note || "").trim() || null,
  });
  const delayMs = 700 + Math.floor(Math.random() * 1100);
  const t = window.setTimeout(() => {
    runFinish(requestId, {
      auto: false,
      mode: mode || "standard",
      note: note || "",
    });
  }, delayMs);
  pendingTimers.set(requestId, t);
}
